module.exports = "<div class=\"pp-overlay pp-gameplay-level-intro-overlay\" data-bind=\"visible: overrideVisibility\">\r\n\r\n    <div class=\"pp-overlay__background twenty-percent\"></div>\r\n\r\n    <div class=\"pp-overlay__modal pp-overlay__modal__auto-size\">\r\n\r\n        <p class=\"pp-gameplay-level-intro-overlay__title\" data-bind=\"text: levelText\"></p>\r\n        <p class=\"pp-gameplay-level-intro-overlay__super-title\">Get ready!</p>\r\n\r\n    </div>\r\n\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/ts/screens/gameplay/level-intro/LevelIntroScreen.html
// module id = 70
// module chunks = 0